var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c(
        "vs-col",
        {
          staticClass: "pt-2 border-top",
          attrs: { "vs-lg": "12", "vs-type": "flex" }
        },
        [
          _c(
            "vs-chip",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.file.emisor.status
                    ? "El proceso se ejecutará llegando el día configurado"
                    : "El proceso no se ejecutará",
                  expression:
                    "file.emisor.status ?\n      'El proceso se ejecutará llegando el día configurado':\n      'El proceso no se ejecutará'"
                }
              ],
              staticClass: "mr-3",
              attrs: { "data-cy": "billing-status" }
            },
            [
              _c("vs-avatar", {
                attrs: {
                  icon: _vm.file.emisor.status ? "check" : "do_not_disturb",
                  color: _vm.file.emisor.status
                    ? this.colores.primario
                    : this.colores.navbar
                }
              }),
              _vm._v(
                " " +
                  _vm._s(_vm.file.emisor.status ? "Activo" : "Inactivo") +
                  " "
              )
            ],
            1
          ),
          _c(
            "vs-chip",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Estado de ejecución: " + _vm.file.executionState,
                  expression: "'Estado de ejecución: '+file.executionState"
                }
              ],
              staticClass: "mr-3",
              attrs: { "data-cy": "billing-status" }
            },
            [
              _c("vs-avatar", {
                attrs: {
                  icon:
                    _vm.file.executionState == "ok"
                      ? "check"
                      : _vm.file.executionState == "pending"
                      ? "do_not_disturb"
                      : "lock",
                  color:
                    _vm.file.executionState == "ok"
                      ? "green"
                      : _vm.file.executionState == "pending"
                      ? this.colores.navbar
                      : "red"
                }
              }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.file.executionState == "ok"
                      ? "Ejecutado"
                      : _vm.file.executionState == "pending"
                      ? "Pendiente"
                      : "Error"
                  ) +
                  " "
              )
            ],
            1
          ),
          _vm.file.emisor.esEnCuota
            ? _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.file.emisor.esEnCuota
                        ? "Es en cuotas"
                        : "No es en cuotas",
                      expression:
                        "file.emisor.esEnCuota ?\n      'Es en cuotas':\n      'No es en cuotas'"
                    }
                  ],
                  staticClass: "mr-3",
                  attrs: { "data-cy": "billing-cuote" }
                },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "credit_card", color: this.colores.primario }
                  }),
                  _vm._v(
                    " En cuota " +
                      _vm._s(_vm.file.emisor.numCuota) +
                      " de " +
                      _vm._s(_vm.file.emisor.numCuotas) +
                      " "
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "vs-chip",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.file.emisor.saveAsDraf
                    ? "Se guarda como borrador"
                    : "Se intenta emitir documento",
                  expression:
                    "file.emisor.saveAsDraf ?\n      'Se guarda como borrador':\n      'Se intenta emitir documento'"
                }
              ],
              staticClass: "mr-3",
              attrs: { "data-cy": "billing-save-as-draf" }
            },
            [
              _c("vs-avatar", {
                attrs: {
                  icon: _vm.file.emisor.saveAsDraf ? "draw" : "print",
                  color: _vm.file.emisor.saveAsDraf
                    ? this.colores.primario
                    : this.colores.navbar
                }
              }),
              _vm._v(
                " " +
                  _vm._s(_vm.file.emisor.saveAsDraf ? "Borrador" : "Emitir") +
                  " "
              )
            ],
            1
          ),
          _c(
            "vs-chip",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value:
                    +_vm.file.emisor.type === 34
                      ? "Factura exenta"
                      : "Factura afecta",
                  expression:
                    "+file.emisor.type === 34 ?\n      'Factura exenta'\n      :\n      'Factura afecta'\n      "
                }
              ],
              staticClass: "mr-4",
              attrs: { "data-cy": "next-billing-type-amount" }
            },
            [
              _c("vs-avatar", {
                attrs: {
                  icon: "title",
                  color:
                    +_vm.file.emisor.type === 33
                      ? this.colores.primario
                      : this.colores.navbar
                }
              }),
              _c("span", [
                _vm._v(" " + _vm._s(_vm.file.emisor.type || 33) + " ")
              ])
            ],
            1
          ),
          _c(
            "vs-chip",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.file.detalle.bruto
                    ? "Este monto ya cuenta con el iva"
                    : "Se calculará el iva sobre este monto",
                  expression:
                    "file.detalle.bruto ?\n      'Este monto ya cuenta con el iva'\n      :\n      'Se calculará el iva sobre este monto'\n      "
                }
              ],
              staticClass: "mr-4",
              attrs: { "data-cy": "next-billing-type-amount" }
            },
            [
              _c("vs-avatar", {
                attrs: {
                  icon: "attach_money",
                  color: !_vm.file.detalle.bruto
                    ? this.colores.primario
                    : this.colores.navbar
                }
              }),
              _vm.file.detalle.bruto
                ? _c("span", [_vm._v(" Bruto ")])
                : _vm._e(),
              !_vm.file.detalle.bruto
                ? _c("span", [_vm._v(" Neto ")])
                : _vm._e()
            ],
            1
          ),
          _c(
            "vs-chip",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Fecha de facturación",
                  expression: "'Fecha de facturación'"
                }
              ],
              staticClass: "mr-4",
              attrs: { "data-cy": "next-billing-type" }
            },
            [
              _c("vs-avatar", { attrs: { icon: "date_range" } }),
              _vm.file.emisor.dayType === "P"
                ? _c("span", [_vm._v(" Primer día del mes ")])
                : _vm._e(),
              _vm.file.emisor.dayType === "U"
                ? _c("span", [_vm._v(" Último día del mes ")])
                : _vm._e(),
              _vm.file.emisor.dayType === "otro"
                ? _c("span", [
                    _vm._v(
                      " El día " + _vm._s(_vm.file.emisor.day) + " de cada mes "
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "vs-chip",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Hora de ejecución",
                  expression: "'Hora de ejecución'"
                }
              ],
              staticClass: "mr-4",
              attrs: { "data-cy": "next-billing-hour" }
            },
            [
              _c("vs-avatar", { attrs: { icon: "hourglass_empty" } }),
              _c("span", [
                _vm._v(" " + _vm._s(_vm.file.emisor.hour || "0") + " ")
              ])
            ],
            1
          ),
          _vm.file.emisor.validityDate
            ? _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Valido hasta",
                      expression: "'Valido hasta'"
                    }
                  ],
                  staticClass: "mr-4",
                  attrs: { "data-cy": "next-billing-date-valid" }
                },
                [
                  _c("vs-avatar", {
                    attrs: {
                      icon: "hourglass_empty",
                      color: _vm.isValidDate ? "green" : "red"
                    }
                  }),
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.file.emisor.validityDate) + " ")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }